import { render } from "./ModelLogo.vue?vue&type=template&id=2023d17d&ts=true"
import script from "./ModelLogo.vue?vue&type=script&lang=ts"
export * from "./ModelLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__